import { camelCase } from 'lodash'
import { DateTime } from 'luxon'
import config from '~/config'
import { Model } from '../Model'

export abstract class BeWizrModel extends Model {

  // BeWizr models don't have these attributes
  public createdAt = DateTime.now()
  public updatedAt = DateTime.now()

  public constructor(raw: Record<string, any>) {
    super(convertJsonToCamelCase(resolveRemoteImages({
      ...raw,
      id: raw.id?.toString(),
      shortDescription: raw.short_description ?? undefined,
    })))
  }

}

function convertJsonToCamelCase(json: any): any {
  if (Array.isArray(json)) {
      return json.map(convertJsonToCamelCase)
  } else if (json != null && typeof json === 'object') {
    return Object.keys(json).reduce((result, key) => ({
      ...result,
      [camelCase(key)]: convertJsonToCamelCase(json[key]),
    }), {})
  }
  return json
}

function resolveRemoteImages(json: any): any {
  if (config.environment !== 'local' || !/^http:\/\/localhost/.test(config.urls.wizr)) { return json }

  if (Array.isArray(json)) {
    return json.map(resolveRemoteImages)
  } else if (json != null && typeof json === 'object') {
    return Object.keys(json).reduce((result, key) => ({
      ...result,
      [key]: resolveRemoteImages(json[key]),
    }), {})
  } else if (typeof json === 'string' && json.startsWith(`${config.urls.wizr}/media/`)) {
    return json.replace(config.urls.wizr, 'https://be.wizr.eu')
  } else {
    return json
  }
}